import {
  AbstractValidationHandler,
  ValidationParams,
} from 'angular-oauth2-oidc';
import { createLocalJWKSet, jwtVerify, JSONWebKeySet } from 'jose';

/**
 * JWT/JWKS validation handler backed by the `jose` library.
 * Replaces the abandoned `angular-oauth2-oidc-jwks` package.
 *
 * - validateSignature: verifies the id_token signature against the JWKS
 *   published by the identity provider.
 * - calcHash: delegates at_hash computation to the browser's SubtleCrypto API.
 */
export class JoseJwksValidationHandler extends AbstractValidationHandler {
  async validateSignature(params: ValidationParams): Promise<void> {
    const rawJwks = (params.jwks ?? (await params.loadKeys())) as JSONWebKeySet;
    const keySet = createLocalJWKSet(rawJwks);
    await jwtVerify(params.idToken, keySet);
  }

  protected async calcHash(
    valueToHash: string,
    algorithm: string,
  ): Promise<string> {
    // algorithm arrives as e.g. 'sha-256' from inferHashAlgorithm;
    // SubtleCrypto expects 'SHA-256'.
    const subtleAlgorithm = algorithm.toUpperCase();
    const encoder = new TextEncoder();
    const data = encoder.encode(valueToHash);
    const hashBuffer = await crypto.subtle.digest(subtleAlgorithm, data);
    return String.fromCharCode(...new Uint8Array(hashBuffer));
  }
}
